import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import './style.css'

const SongkranPage = () => {
  const { t } = useTranslation()

  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-about-text">
              <div className="wpo-section-title">
                <h2>{t('promo.songkran_line1')}</h2>
              </div>
              <p>{t('promo.songkran_line2')}</p>
              <p>{t('promo.songkran_line3')}</p>
              <p>{t('promo.songkran_line4')}</p>
              <ul>
                <li>{t('promo.songkran_line5')}</li>
                <li>{t('promo.songkran_line6')}</li>
                <li>{t('promo.songkran_line7')}</li>
                <li>{t('promo.songkran_line8')}</li>
                <li>{t('promo.songkran_line9')}</li>
              </ul>
              <p>{t('promo.songkran_line10')}</p>
              <p>{t('promo.songkran_line11')}</p>
              
              <div className="btns">
                <Link to="/destination2" className="theme-btn-s2">{t('navigation.all_destinations')}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SongkranPage
